module.exports = ".customer {\n  color: #5CB85C;\n  margin-top: 40px;\n  font-size: 1rem;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/auswertung/auswertung.component.css
// module id = ./src/app/auswertung/auswertung.component.css
// module chunks = main